import { getMediasVariant } from "~/features/navigation/components/TopBar/HeaderCircle";
import { FetchFCCRecommendedProducts } from "~/features/saleRecommendations/components/FCCRecommendationsSection";
import { PurchasePlaceProvider } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { useBootstrapConfiguration } from "~/app/config/useAppConfig";

export interface FCCGapProdRecomSectionProps {
  className?: string;
}

export const FCCGapProductRecommendation = (props: FCCGapProdRecomSectionProps) => {
  const configuration = useBootstrapConfiguration();
  const role = getMediasVariant();
  const isBusiness = role === "business";

  if (!isBusiness) {
    return null;
  }
  if (!configuration?.showFccGapProductsRecommendation) {
    return null;
  }
  return <FetchFCCRecommendedProducts {...props} />;
};

export function createSchaefflerFccRecommendationComponent() {
  return (
    <PurchasePlaceProvider value={"HOME"}>
      <FCCGapProductRecommendation />
    </PurchasePlaceProvider>
  );
}
